import React from "react";
import styled from "styled-components";

interface Props {
  delay: number;
  onClick?: () => void;
}

const StartButton = ({ delay, onClick }: Props) => {
  return (
    <Button delay={delay} onClick={onClick}>
      시작하기
    </Button>
  );
};

export default StartButton;

const Button = styled.button<{ delay: number }>`
  font-family: "iceSotong-Rg";

  cursor: pointer;

  visibility: hidden;
  color: white;
  border: none;

  border-radius: 10px;
  font-weight: 600;
  font-size: 20px;
  padding: 10px;
  background-image: linear-gradient(#e0583a, #2c0000);

  animation: ani-visible 1000ms;
  animation-fill-mode: forwards;

  animation-delay: ${({ delay }) => `${delay}s`};
  opacity: 0;

  transition: 200ms;

  @keyframes ani-visible {
    from {
      opacity: 0;

      visibility: hidden;
    }

    to {
      opacity: 1;

      visibility: visible;
    }
  }

  &:active {
    transform: scale(0.9);
  }
`;
